const EXPANDED_PARAM = "expanded";
const FOCUSED_PARAM = "focused";
// Kept readable so existing deep links from the Service Layout still open a task.
const LEGACY_PARAM = "modelVersionTaskID";

const toTaskId = (value) => {
	const id = Number.parseInt(value, 10);
	return Number.isInteger(id) && id > 0 ? id : null;
};

const parseIdList = (value) =>
	value
		? [...new Set(value.split(",").map(toTaskId).filter(Boolean))]
		: [];

/**
 * The one place that knows how expanded tasks are written into the URL.
 *
 * `expanded` is the set of open rows and `focused` is the one the user is on, so
 * a refresh restores both the rows and the position. Both the reader and the
 * writer live here so the format cannot drift between them.
 */
export const parseExpandedTasks = (search) => {
	const params = new URLSearchParams(search);
	const expandedIds = parseIdList(params.get(EXPANDED_PARAM));

	if (expandedIds.length === 0) {
		const legacyId = toTaskId(params.get(LEGACY_PARAM));
		return legacyId
			? { expandedIds: [legacyId], primaryId: legacyId }
			: { expandedIds: [], primaryId: null };
	}

	const focusedId = toTaskId(params.get(FOCUSED_PARAM));
	return {
		expandedIds,
		primaryId: focusedId && expandedIds.includes(focusedId) ? focusedId : null,
	};
};

export const buildExpandedTasksSearch = (search, { expandedIds, primaryId }) => {
	const params = new URLSearchParams(search);
	params.delete(LEGACY_PARAM);

	if (!expandedIds?.length) {
		params.delete(EXPANDED_PARAM);
		params.delete(FOCUSED_PARAM);
		return params.toString();
	}

	params.set(EXPANDED_PARAM, expandedIds.join(","));
	if (primaryId && expandedIds.includes(primaryId)) {
		params.set(FOCUSED_PARAM, String(primaryId));
	} else {
		params.delete(FOCUSED_PARAM);
	}
	return params.toString();
};
